import { Route } from 'react-router-dom';
import { Error404 } from './404';
import { Error500 } from './500';

export const errorRoutes = [
  <Route key="500" path="/500" element={<Error500 />} />,
  <Route key="404" path="*" element={<Error404 />} />,
];
